/**
 * Brand, contact and navigation configuration.
 *
 * ⚠️ Do not edit the values here — edit the `.env` file at the project root.
 * This module only reads those variables and derives helpers from them. The
 * fallbacks below exist so the site still renders if `.env` is missing.
 *
 * Changing `.env` requires restarting the dev server (or rebuilding), because
 * Create React App inlines these values at build time.
 */

const env = process.env;

/** Strips any trailing slash so `${SITE.url}/blog` never becomes `//blog`. */
const trimSlash = (value) => String(value ?? '').replace(/\/+$/, '');

export const SITE = {
  name: env.REACT_APP_SITE_NAME || 'TVNIMO',
  url: trimSlash(env.REACT_APP_SITE_URL || 'https://tvnimo.com'),
  locale: 'fr_FR',
};

/** Domain without protocol, e.g. for display or schema.org. */
SITE.domain = SITE.url.replace(/^https?:\/\//, '');

SITE.description = `Abonnement IPTV premium pour la France et la Belgique : plus de 79 000 chaînes et 249 000 films et séries en 4K, compatibles Smart TV, Android, Fire Stick et PC.`;

export const CONTACT = {
  /** International format, digits only — required by the wa.me URL scheme. */
  whatsappNumber: (env.REACT_APP_WHATSAPP_NUMBER || '447478034690').replace(/\D/g, ''),
  whatsappDisplay: env.REACT_APP_WHATSAPP_DISPLAY || '+44 7478 034690',
  email: env.REACT_APP_EMAIL || 'contact@tvnimo.com',
  supportEmail: env.REACT_APP_SUPPORT_EMAIL || 'support@tvnimo.com',
};

/** External checkout endpoint; the appended id is the price in euros. */
export const ORDER_URL = env.REACT_APP_ORDER_URL || `${SITE.url}/order.php`;

/** Build a wa.me deep link, optionally pre-filling the message. */
export const whatsappLink = (message) =>
  `https://wa.me/${CONTACT.whatsappNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

export const FREE_TRIAL_MESSAGE = "Bonjour, je souhaite un test IPTV gratuit, s'il vous plaît.";

/**
 * Landing-page sections. Every `href` here must match a Section `id` rendered
 * on the home route — these ids are asserted by the anchor test.
 */
export const NAV_LINKS = [
  { label: 'Forfaits', href: '/#forfaits' },
  { label: 'Chaînes', href: '/#chaines' },
  { label: 'Installation', href: '/#installation' },
  { label: 'Appareils', href: '/#appareils' },
  { label: 'FAQ', href: '/#faq' },
  { label: 'Blog', href: '/blog' },
];

export const FOOTER_LINKS = {
  navigation: NAV_LINKS,
  legal: [
    { label: "Conditions d'utilisation", href: '/terms' },
    { label: 'Politique de confidentialité', href: '/privacy' },
    { label: 'Politique de remboursement', href: '/refund' },
  ],
};
